<app-attendee-layout>
  <h1
    class="vtmn-title-4"
    routerLinkActive="tab-bar__item--active"
    #rla="routerLinkActive"
  >
    {{ 'attendee.result_page.activities.title' | translate }} {{ searchTherm }}
  </h1>
  <app-attendee-home-filters-desktop
    *ngIf="!isTabletDevice"
    class="block mt-2 md:mt-0"
    [city]="defaultFilters?.city"
    [radius]="defaultFilters?.radius"
    [placeId]="defaultFilters?.placeId"
    [dateRange]="dateRange"
    [searchMode]="searchModeEnum.AUTO"
    [sportsGroup]="sportsGroup"
    (searched)="updateFilters($event)"
  ></app-attendee-home-filters-desktop>

  <app-attendee-home-filters-mobile
    *ngIf="isTabletDevice"
    class="block mt-2 -mx-3 xs:-mx-6 sm:-mx-9 md:mt-0 lg:mx-0"
    [city]="defaultFilters?.city"
    [radius]="defaultFilters?.radius"
    [placeId]="defaultFilters?.placeId"
    [dateRange]="dateRange"
    [searchMode]="searchModeEnum.AUTO"
    [sportsGroup]="sportsGroup"
    (searched)="updateFilters($event)"
  ></app-attendee-home-filters-mobile>

  <div class="mt-3 mb-4 lg:mt-4" *ngIf="queryParamParsed">
    <app-attendee-age-filter
      class="mr-2"
      [defaultRange]="defaultFilters?.ageRange"
      (selected)="updateFilters($event)"
      data-test="age-filter"
    >
    </app-attendee-age-filter>

    <app-attendee-price-filter
      class="mr-2"
      [defaultRange]="defaultFilters?.priceRange"
      (selected)="updateFilters($event)"
      data-test="price-filter"
    >
    </app-attendee-price-filter>
  </div>
  <app-router-tab-bar [tabBarLinks]="tabBarlinks" *ngIf="tabBarlinks">
    <router-outlet></router-outlet>
  </app-router-tab-bar>
</app-attendee-layout>
